import {
  Component,
  ContentChild,
  HostListener,
  Input,
  Output,
  TemplateRef,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { ScrollPanelModule } from 'primeng/scrollpanel';

@Component({
  selector: 'custom-drawer',
  standalone: true,
  imports: [DrawerModule, DialogModule, CommonModule, ScrollPanelModule],
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.scss',
})
export class CustomDrawerComponent implements OnInit {
  private _visible = false;
  private _closable = true;

  @Input() styleClass?: string;

  @Input()
  set visible(val: boolean) {
    this._visible = val;
  }
  get visible() {
    return this._visible;
  }
  @Input()
  set closable(val: boolean) {
    this._closable = val;
  }
  get closable() {
    return this._closable;
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onShow = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<boolean>();

  @ContentChild('header') headerRef!: TemplateRef<any>;
  @ContentChild('content') contentRef!: TemplateRef<any>;
  @ContentChild('footer') footerRef!: TemplateRef<any>;

  mode: 'drawer' | 'dialog' = 'dialog';

  ngOnInit(): void {
    this.updateMode(window.innerWidth);
  }

  @HostListener('window:resize', [])
  onResize() {
    this.updateMode(window.innerWidth);
  }

  private updateMode(width: number) {
    this.mode = width <= 768 ? 'drawer' : 'dialog';
  }

  close() {
    this.visibleChange.emit(false);
    this._visible = false;
  }

  onVisibleChange(newValue: boolean) {
    this._visible = newValue;
    this.visibleChange.emit(newValue);
    if (newValue) this.onShow.emit();
    else this.onHide.emit();
  }
}
